// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/app_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppIconService } from "./app_icons";
import type { BulkGetAppIconsResponse } from "./app_icons";
import type { BulkGetAppIconsRequest } from "./app_icons";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetAppIconResponse } from "./app_icons";
import type { GetAppIconRequest } from "./app_icons";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.assets.v1.AppIconService
 */
export interface IAppIconServiceClient {
    /**
     * @generated from protobuf rpc: GetAppIcon
     */
    getAppIcon(input: GetAppIconRequest, options?: RpcOptions): UnaryCall<GetAppIconRequest, GetAppIconResponse>;
    /**
     * @generated from protobuf rpc: BulkGetAppIcons
     */
    bulkGetAppIcons(input: BulkGetAppIconsRequest, options?: RpcOptions): UnaryCall<BulkGetAppIconsRequest, BulkGetAppIconsResponse>;
}
/**
 * @generated from protobuf service c1.api.assets.v1.AppIconService
 */
export class AppIconServiceClient implements IAppIconServiceClient, ServiceInfo {
    typeName = AppIconService.typeName;
    methods = AppIconService.methods;
    options = AppIconService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetAppIcon
     */
    getAppIcon(input: GetAppIconRequest, options?: RpcOptions): UnaryCall<GetAppIconRequest, GetAppIconResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppIconRequest, GetAppIconResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkGetAppIcons
     */
    bulkGetAppIcons(input: BulkGetAppIconsRequest, options?: RpcOptions): UnaryCall<BulkGetAppIconsRequest, BulkGetAppIconsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkGetAppIconsRequest, BulkGetAppIconsResponse>("unary", this._transport, method, opt, input);
    }
}
